import { BaseService } from './BaseService';
import {
  Action,
  ActionType,
  Dispatcher,
  Position
} from '../../index';

/**
 * Service must be registered to Dispatcher on loading Application.
 * Use Dispatcher.useService(services, actions)
 * services represents object with service modules to register on dispatcher
 * actions object represents all actions which are used in conjunction with services
 *
 * Example
 * Dispatcher.useServices({
 *  ActivityService: [ActivityService],
 *  AuthService: [AuthService]
 *  }, {
 *  ...AuthActions
 * });
 */
export class Service extends BaseService {
  /**
   * Entry point for dispatching actions from dispatcher modules.
   * @param {string} actionName Name of action that is dispatching.
   * @param {ActionType/Position/String} actionType Action configuration.
   * @param {any} data Data that will be added to dispatchers `appOperationData` before action is executed.
   * @param {string} methodName
   */
  public dispatch(actionName: string, actionType?: ActionType | Position | string, data?: any, methodName?: string): void {
    Dispatcher.dispatchFromModule(this.moduleName, actionName, actionType, data, methodName);
  }

  public registerServiceToDispatcher(actions: { [key: string]: Action } = {}): void {
    Dispatcher.useServices(
      {
        [this.moduleName]: [this]
      },
      {
        ...actions
      }
    );
  }
}
